export default "__VITE_ASSET__$eiDTqJY__"